import { render, staticRenderFns } from "./UserSearch.vue?vue&type=template&id=90699bfa&"
import script from "./UserSearch.vue?vue&type=script&lang=js&"
export * from "./UserSearch.vue?vue&type=script&lang=js&"
import style0 from "./UserSearch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCheckbox,VFlex,VLayout})


/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('90699bfa')) {
      api.createRecord('90699bfa', component.options)
    } else {
      api.reload('90699bfa', component.options)
    }
    module.hot.accept("./UserSearch.vue?vue&type=template&id=90699bfa&", function () {
      api.rerender('90699bfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UserSearch.vue"
export default component.exports